// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a45c53dc","455":"d191036c","977":"e15f659f"}[chunkId] + ".chunk.js";
};